// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__oHnPI","colMin":"styles_colMin__fhFUM","colCheckbox":"styles_colCheckbox__KkPV4"};